import React from 'react';
import styled from "styled-components";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

const Icon = styled.a`
  font-size: 14px;
  text-decoration: none;
  color: var(--color-table-filter);
  margin: 0;
  cursor: pointer;

  &:hover {
    color: var(--color-brand-pink-primary);
  }

  transition: all 0.3s ease-in-out;
`

const RowNavigationIcon = ({title, href, icon,onClick}) => {
    return (
        <Icon title={title} target="_blank" rel="noopener noreferrer" href={href} onClick={onClick}>
            <FontAwesomeIcon icon={icon}/>
        </Icon>
    );
};

export default RowNavigationIcon;
